import {Router} from '@angular/router';
import {RoadtripMapItem} from '../../../core/api/resources/roadtrip-map-item.resource';

/**
 * The map service is injected at boot time, see main.ts and map.injection-token.ts
 */
export abstract class MapService {

  constructor(protected router: Router) {
  }

  abstract setCenter(lat: number, lng: number): void;

  abstract drawUserMarker(coords: { lat: number, lng: number }): void;

  abstract drawRoadtripMarker(roadtrip: RoadtripMapItem): void;

  abstract setMap(map: any): any;

  abstract clear(): void;
}
